import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4, 6, 6, 6),
  },
}));

export default useStyles;
